
import React from 'react';

export const VPNSection: React.FC = () => {
  return (
    <section id="vpn" className="py-20 lg:py-32 bg-[#F5F7FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Side - VPN Server Map */}
          <div className="relative">
            <div className="bg-gradient-to-br from-[#0A1628] to-[#1E3A5F] rounded-3xl p-8 h-96 relative overflow-hidden">
              {/* Background pattern */}
              <div className="absolute inset-0 opacity-10">
                <img 
                  src="https://public.readdy.ai/ai/img_res/94e1a80e0753a53aa9d02d99d6e67a98.jpg"
                  alt="Global VPN Network"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              
              {/* Glowing connection points */}
              <div className="absolute top-16 left-12 w-3 h-3 bg-[#00D4FF] rounded-full animate-pulse shadow-lg shadow-blue-400/50"></div>
              <div className="absolute top-24 right-16 w-3 h-3 bg-[#00D4FF] rounded-full animate-pulse shadow-lg shadow-blue-400/50"></div>
              <div className="absolute bottom-20 left-20 w-3 h-3 bg-[#00D4FF] rounded-full animate-pulse shadow-lg shadow-blue-400/50"></div>
              <div className="absolute bottom-16 right-12 w-3 h-3 bg-[#00D4FF] rounded-full animate-pulse shadow-lg shadow-blue-400/50"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-green-400 rounded-full animate-pulse shadow-lg shadow-green-400/50"></div>

              {/* Feature labels */}
              <div className="absolute top-6 left-6 flex flex-wrap gap-3">
                <div className="bg-white/10 backdrop-blur-md px-3 py-2 rounded-lg text-white text-xs font-medium border border-white/20">
                  256-bit Encryption
                </div>
                <div className="bg-white/10 backdrop-blur-md px-3 py-2 rounded-lg text-white text-xs font-medium border border-white/20">
                  No Logs
                </div>
                <div className="bg-white/10 backdrop-blur-md px-3 py-2 rounded-lg text-white text-xs font-medium border border-white/20">
                  Kill Switch
                </div>
              </div>

              {/* Connection lines */}
              <svg className="absolute inset-0 w-full h-full">
                <line x1="20%" y1="30%" x2="80%" y2="40%" stroke="#00D4FF" strokeWidth="2" opacity="0.6" strokeDasharray="5,5">
                  <animate attributeName="stroke-dashoffset" values="0;-20" dur="3s" repeatCount="indefinite"/>
                </line>
                <line x1="30%" y1="70%" x2="70%" y2="20%" stroke="#00D4FF" strokeWidth="2" opacity="0.6" strokeDasharray="5,5">
                  <animate attributeName="stroke-dashoffset" values="0;-20" dur="4s" repeatCount="indefinite"/>
                </line>
              </svg>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-[#0A1628] mb-6">
                Military-Grade VPN Protection
              </h2>
              
              {/* Feature Tags */}
              <div className="flex flex-wrap gap-4 mb-8">
                <span className="border-2 border-[#00D4FF] text-[#00D4FF] px-4 py-2 rounded-full text-sm font-medium">
                  Fast
                </span>
                <span className="text-gray-600 px-4 py-2 text-sm font-medium">
                  Secure
                </span>
                <span className="text-gray-600 px-4 py-2 text-sm font-medium">
                  Private
                </span>
              </div>
            </div>

            {/* Technology Card */}
            <div className="bg-[#0D1B2A] rounded-3xl p-8 relative overflow-hidden">
              <div className="absolute top-6 left-6">
                <span className="bg-[#00D4FF] text-white text-xs font-bold px-3 py-1 rounded-full">
                  TECHNOLOGY
                </span>
              </div>
              
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
                <div className="space-y-4">
                  <h3 className="text-2xl font-bold text-white">
                    Advanced Security Protocol
                  </h3>
                  <p className="text-gray-300 leading-relaxed">
                    Our VPN uses military-grade AES-256 encryption with perfect forward secrecy. 
                    Every connection is protected by multiple security layers, ensuring your data 
                    remains completely private and secure from any surveillance or cyber threats.
                  </p>
                </div>
                
                <div className="relative">
                  <img 
                    src="https://readdy.ai/api/search-image?query=abstract%20cybersecurity%20technology%20visualization%20with%20blue%20digital%20encryption%20patterns%2C%20data%20flow%20streams%2C%20shield%20symbols%2C%20modern%20tech%20aesthetic%2C%20dark%20background%20with%20glowing%20blue%20accents&width=300&height=200&seq=tech-viz-001&orientation=landscape"
                    alt="Security Technology Visualization"
                    className="w-full h-32 object-cover object-center rounded-2xl"
                  />
                  <div className="absolute inset-0 bg-gradient-to-tr from-[#00D4FF]/20 to-transparent rounded-2xl"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
